import type { TextFieldProps } from '@mui/material'
import TextField from '@mui/material/TextField'
import { Controller, useFormContext } from 'react-hook-form'

type Props = Omit<TextFieldProps, 'variant'> & {
  name: string
  label: string
  variant?: TextFieldProps['variant']
}

export const FormTextfield = ({ name, label, variant = 'outlined', fullWidth = true, ...rest }: Props) => {
  const {
    control,
    formState: { errors },
  } = useFormContext()

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <TextField
          {...rest}
          {...field}
          label={label}
          variant={variant}
          fullWidth={fullWidth}
          helperText={errors[name]?.message?.toString() || ''}
          error={!!errors[name]?.message}
        />
      )}
    />
  )
}
